import { AlertExpression, Condition_SecurityAlertCondition_Operator } from "../../../proto/generated/nexus"
import { ChartAlertSnapshot } from "../alertModal.typings"

export type AlertExpressionDropdownProps = {
    isConditionalOrder: boolean
    expression: AlertExpression,
    chartSnapshot: ChartAlertSnapshot,
    comparedExpression: AlertExpression,
    mode: "lhs" | "rhs",
    onExpressionChange: (expression: AlertExpression, change: keyof AlertExpression) => void,
    onOutputChange: (output: string) => void,
    className?: string
    /** When set (e.g. security price multiplier), fixed-value RHS is shown as `fixedValue / scale` and edits are stored as display × scale (native). */
    fixedValueScale?: number
    /** Used to default OHLC source when choosing compare security (e.g. crossing → high/low). */
    operator?: Condition_SecurityAlertCondition_Operator
}

export enum FixedExpressionOutputTypes {
    PRICE = "price",
    VOLUME = "volume",
    VALUE = "value",
    /** Chart primary + compare symbols with optional interval override */
    COMPARE_SECURITY = "compare_security",
    DRAWING = "drawing",
    PATTERN = "pattern",
}

export type DropdownOption = {
    label: string,
    value: string
}